interface DocumentIE11 extends Document {
    documentMode: unknown;
}

export function isIE11(): boolean {
    return !!window.MSInputMethodContext && !!(document as DocumentIE11).documentMode;
}